export default __webpack_public_path__ + "static/media/WillgoLogo.4eb91bd7.png";